function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
export const FigmaLogoFilledIcon = /*#__PURE__*/forwardRef(({
  className,
  style,
  ariaLabel,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  ref: ref,
  className: className,
  "aria-label": ariaLabel || "figma, logo, logo filled, figma filled",
  style: style,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13 7C13.7957 7 14.5587 6.68393 15.1213 6.12132C15.6839 5.55871 16 4.79565 16 4C16 3.20435 15.6839 2.44129 15.1213 1.87868C14.5587 1.31607 13.7957 1 13 1H7C6.20435 1 5.44129 1.31607 4.87868 1.87868C4.31607 2.44129 4 3.20435 4 4C4 4.79565 4.31607 5.55871 4.87868 6.12132C5.44129 6.68393 6.20435 7 7 7C6.20435 7 5.44129 7.31607 4.87868 7.87868C4.31607 8.44129 4 9.20435 4 10C4 10.7956 4.31607 11.5587 4.87868 12.1213C5.44129 12.6839 6.20435 13 7 13C6.40666 13 5.82664 13.1759 5.33329 13.5056C4.83994 13.8352 4.45543 14.3038 4.22836 14.8519C4.0013 15.4001 3.94189 16.0033 4.05765 16.5853C4.1734 17.1672 4.45912 17.7018 4.87868 18.1213C5.29824 18.5409 5.83279 18.8266 6.41473 18.9424C6.99667 19.0581 7.59987 18.9987 8.14805 18.7716C8.69623 18.5446 9.16477 18.1601 9.49441 17.6667C9.82405 17.1734 10 16.5933 10 16V7H13Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 13C14.6569 13 16 11.6569 16 10C16 8.34314 14.6569 7 13 7C11.3431 7 10 8.34314 10 10C10 11.6569 11.3431 13 13 13Z",
  fill: "currentColor"
})));
export default FigmaLogoFilledIcon;